import React from 'react';

import { Center, Flex, Text } from '@chakra-ui/react';
import { captureException } from '@sentry/nextjs';
import Image from 'next/image';

import {
  SENTRY_TAGS,
  SENTRY_TAGS_TYPE_VALUES,
} from '@/constants/monitoring.constants';

interface AppErrorBoundaryProps {
  children: React.ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

class AppErrorBoundary extends React.Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  constructor(props: AppErrorBoundaryProps) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: Error, errorInfo: React.ErrorInfo) {
    captureException(error, {
      contexts: {
        error: {
          reactInfo: errorInfo,
        },
      },
      tags: {
        [SENTRY_TAGS.TYPE]: SENTRY_TAGS_TYPE_VALUES.ERROR_BOUNDARY,
      },
    });

    return { hasError: true };
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Flex
          direction={{
            base: 'column-reverse',
            md: 'row',
          }}
        >
          <Flex direction="column">
            <Center>
              <Text fontSize="64px" lineHeight="200%" fontWeight={700}>
                Something went wrong.
              </Text>

              <Text color="textSecondary" fontSize="12px">
                We&apos;re sorry, but an unexpected error has occurred. Please
                try again later.
              </Text>
            </Center>
          </Flex>

          <Image
            src="https://www.staderlabs.com/assets/images/404.svg"
            alt="cavemen with cables"
            width={400}
            height={400}
          />
        </Flex>
      );
    }

    return this.props.children;
  }
}

export { AppErrorBoundary };
